// Bridge from a visual's MappedColumn to the shared transaction list-table
// display renderer (@twasta/page-runtime/txn). A column's `display` DisplayFormat
// was ported FROM twasta's transaction list-table, so the same <DisplayCell>
// (data bars, status tags, ratings, dates, links, …) renders visual cells too.
// Companion-column formats (two_line / date_range / bullet-with-max) work here
// because the full row is passed.

import {
  DisplayCell as PgDisplayCell,
  displayPlainText as pgDisplayPlainText,
  type ColumnDef,
  type DisplayFormat,
} from '@twasta/page-runtime/txn'
import type { MappedColumn } from './dataUtils'

export { PgDisplayCell as DisplayCell }
export type { ColumnDef }

/** Minimal ColumnDef synthesized from a MappedColumn (row data is keyed by NAME,
 *  so db_name = name makes companion pickers + previews resolve). */
export function toColDef(c: MappedColumn): ColumnDef {
  return {
    name: c.name,
    db_name: c.name,
    heading: c.label,
    display: c.display as DisplayFormat | undefined,
  } as ColumnDef
}

/** True when the column carries a rich (non-text) display format. */
export function hasRichDisplay(c: MappedColumn): boolean {
  const t = (c.display as { type?: string } | undefined)?.type
  return !!t && t !== 'text'
}

/** Plain-text rendering of a value under a column's display format (for card
 *  centre values / feed lines where a rich React block doesn't fit). */
export function displayPlainText(
  value: unknown,
  c: MappedColumn,
  row?: Record<string, unknown>,
  columns?: ColumnDef[],
): string {
  return pgDisplayPlainText(value, toColDef(c), row, columns)
}
